<template>
  <div
    id="wrapper"
    class="toggled">

    <!-- header title -->
    <j-headful :title="$route.meta.title"/>

    <!-- sidebar -->
    <j-sidebar-app
      :menus-items="menusDetails"
      class="siderbar-app"/>

    <!-- Page Content -->
    <div
      id="page-content-wrapper"
      style="display: block">

      <!-- navbar -->
      <j-navbar-app
        :user="user"
        module="BIMBINGAN KONSELING"/>

      <!-- main content -->
      <div class="wrapper-content">
        <transition name="fadeout">
          <router-view/>
        </transition>
      </div>

    </div>

    <!-- notification screen -->
    <j-loading-screen
      ref="loadingScreen"
      :message="loading_message"/>
    <j-info-screen
      ref="infoScreen"
      :message="info_message"/>
    <j-problem-screen
      ref="problemScreen"
      :message="problem_message"
      :code="problem_code"/>
    <j-success-screen
      ref="successScreen"
      :message="success_message"/>

  </div>
</template>

<script>
/* eslint-disable global-require,import/no-duplicates,vue/name-property-casing */
import { jPrivCompanySettings } from '@/privilage/company-settings/jPrivCompanySettings';
import { jPrivPackages } from '@/privilage/packages/jPrivPackages';
import { jPrivRoles } from '@/privilage/roles/jPrivRoles';
import jMixNotificationScreen from '@/mixins/components/notification-screen/jMixNotificationScreen';
// import jMixSidebar from '@jojocoders/jojonomic-ui/src/Mixins/jMixSidebar';
import jNavbarApp from '@/layouts/navbar/jNavbarApp';
import Vue from 'vue';

export default {
  name: 'jWrapperBK',
  components: {
    jNavbarApp,
  },
  mixins: [
    jPrivCompanySettings,
    jPrivPackages,
    jPrivRoles,
    jMixNotificationScreen,
    // jMixSidebar,
  ],
  data() {
    return {
      arrayOfIcon: [],
      user: {
        submenu: {
          menus: [
            {
              id: 2,
              text: 'Logout',
              href: '/logout',
            },
          ],
        },
      },
    };
  },
  computed: {
    menusDetails() {
      return [
        {
          parent: {
            name: 'HOME',
            icon: 'home',
            href: '/dashboard/bk',
            isShow: true,
          },
        },
        // {
        //   parent: {
        //     name: 'ADMINISTRASI ABSEN',
        //     icon: 'file-text-o',
        //     href: '/admin-absen',
        //     isShow: true,
        //   },
        // },
        {
          parent: {
            name: 'KONSELING',
            icon: 'file-text-o',
            href: '/konseling',
            isShow: true,
          },
        },
        {
          parent: {
            name: 'PENELURUSAN LULUSAN',
            icon: 'file-text-o',
            href: '/penelurusan-lulusan',
            isShow: true,
          },
        },
        {
          parent: {
            name: 'PENELURUSAN CALON PENERIMA BANTUAN',
            icon: 'file-text-o',
            href: '/penelurusan-calon-penerima-bantuan',
            isShow: true,
          },
        },
      ];
    },
  },
  mounted() {
    setInterval(() => {
      if (!Vue.ls.get('Token')) {
        this.$router.replace('/logout');
        window.location = '/';
      }
    }, 1000);
  },
  created() {
  },
};
</script>



// WEBPACK FOOTER //
// src/layouts/jWrapperBK.vue